var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSetaRenovacaoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 24,
    viewBox: "0 0 48 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.172 11L34.808 5.636L36.222 4.222L44 12L36.222 19.778L34.808 18.364L40.172 13H28V11H40.172Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    y1: 12,
    x2: 28,
    y2: 12,
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSetaRenovacaoWhite);
export default __webpack_public_path__ + "static/media/ic-seta-renovacao-white.6782fcb7be2c7b8d0146ccecefb8a4fc.svg";
export { ForwardRef as ReactComponent };